import { defineNuxtPlugin } from '#app'
import { usePinia } from '#imports'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

export default defineNuxtPlugin(nuxtApp => {
  if (import.meta.client) {
    const pinia = usePinia()
    pinia.use(piniaPluginPersistedstate)
  }
})
